var locale_nl = {
  APPARAAT: 'apparaat',
  ARTIKEL: 'artikel',
  AUDIOCASSETTE: 'audiocassette',
  BACHELORPROEF: 'bachelorproef',
  BOEK: 'boek',
  CD: 'cd',
  CDROM: 'cdrom',
  CDTRACK: 'cdtrack',
  DEELTITEL: 'deeltitel',
  DIDACTISCH_MATERIAAL: 'didactical material',
  DVD: 'dvd',
  E_BOEK: 'Electronische publicatie',
  EBOOK: 'Electronische publicatie',
  WEBSITE_DATABANK: 'website / databank',
  HANDBOEK_CURUSUS: 'handboek / cursus',
  LOSBLADIG_WERK: 'losbladig werk',
  NASLAGWERK: 'naslagwerk',
  POSTER: 'poster',
  SPELMATERIAAL: 'spelmateriaal',
  TIJDSCHRIFT: 'tijdschrift',
  TRANSPARANT: 'transparant',
  VIDEO: 'video',
  ERRATUM: 'erratum',
  HOOFDARTIKEL: 'hoofdartikel',
  UNKNOWN: 'unknown',
  HANDBOEK_HANDLEIDING: 'Handboek / handleiding',
  TIJDSCHRIFT_ARTIKEL: 'Tijdschrift / artikel'
};
var locale_en = {
  APPARAAT: 'device',
  ARTIKEL: 'Article',
  AUDIOCASSETTE: 'audio cassette',
  BACHELORPROEF: 'Dissertation',
  BOEK: 'Book',
  CD: 'cd',
  CDROM: 'cd-rom',
  CDTRACK: 'cd track',
  DEELTITEL: 'Subtitle',
  DIDACTISCH_MATERIAAL: 'didactisch_materiaal',
  DVD: 'dvd',
  E_BOEK: 'Electronic publication',
  EBOOK: 'Electronic publication',
  WEBSITE_DATABANK: 'Website/Database',
  HANDBOEK_CURUSUS: 'manual / course',
  LOSBLADIG_WERK: 'Unbound work',
  NASLAGWERK: 'reference work',
  POSTER: 'poster',
  SPELMATERIAAL: 'games',
  TIJDSCHRIFT: 'Journal',
  TRANSPARANT: 'transparant',
  VIDEO: 'video',
  ERRATUM: 'erratum',
  HOOFDARTIKEL: 'Editorial',
  UNKNOWN: 'unknown',
  HANDBOEK_HANDLEIDING: 'Course/Manual',
  TIJDSCHRIFT_ARTIKEL: 'Journal/Article'
};

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _publicatietypes;

var APPARAAT = "apparaat";
var ARTIKEL = "artikel";
var AUDIOCASSETTE = "audiocassette";
var BACHELORPROEF = "bachelorproef";
var BOEK = "boek";
var CD = "cd";
var CDROM = "cdrom";
var CDTRACK = "cdtrack";
var DEELTITEL = "deeltitel";
var DIDACTISCH_MATERIAAL = "didactisch_materiaal";
var DVD = "dvd";
var E_BOEK = "ebook";
var EBOOK = "ebook";
var WEBSITE_DATABANK = "website_databank";
var HANDBOEK_CURUSUS = "handboek_cursus";
var LOSBLADIG_WERK = "losbladig_werk";
var NASLAGWERK = "naslagwerk";
var POSTER = "poster";
var SPELMATERIAAL = "spelmateriaal";
var TIJDSCHRIFT = "tijdschrift";
var TRANSPARANT = "transparant";
var VIDEO = "video";
var ERRATUM = "erratum";
var HOOFDARTIKEL = "hoofdartikel";
var UNKNOWN = "unknown";
var publicatietypes = (_publicatietypes = {
  APPARAAT: APPARAAT,
  ARTIKEL: ARTIKEL,
  AUDIOCASSETTE: AUDIOCASSETTE,
  BACHELORPROEF: BACHELORPROEF,
  BOEK: BOEK,
  CD: CD,
  CDROM: CDROM,
  CDTRACK: CDTRACK,
  DEELTITEL: DEELTITEL,
  DIDACTISCH_MATERIAAL: DIDACTISCH_MATERIAAL,
  DVD: DVD,
  E_BOEK: E_BOEK,
  EBOOK: EBOOK,
  ERRATUM: ERRATUM,
  WEBSITE_DATABANK: WEBSITE_DATABANK,
  HANDBOEK_CURUSUS: HANDBOEK_CURUSUS,
  LOSBLADIG_WERK: LOSBLADIG_WERK,
  NASLAGWERK: NASLAGWERK,
  POSTER: POSTER,
  SPELMATERIAAL: SPELMATERIAAL,
  TIJDSCHRIFT: TIJDSCHRIFT,
  TRANSPARANT: TRANSPARANT,
  VIDEO: VIDEO
}, defineProperty(_publicatietypes, 'ERRATUM', ERRATUM), defineProperty(_publicatietypes, 'HOOFDARTIKEL', HOOFDARTIKEL), defineProperty(_publicatietypes, 'UNKNOWN', UNKNOWN), _publicatietypes);

var getPublicatieTypeLabel = function getPublicatieTypeLabel(publicatietype) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'nl';

  var source = function source(locale) {
    switch (locale) {
      case 'nl':
        return locale_nl;
        break;

      case 'en':
        return locale_en;
        break;

      default:
        return locale_nl;
    }
  };

  var label = source(locale)[publicatietype.toUpperCase()];
  if (!label || label === '') return publicatietype;
  label = label.charAt(0).toUpperCase() + label.slice(1);
  return label;
};

var getPublicatieTypeIcon = function getPublicatieTypeIcon(publicatietype) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var rs = "";

  switch (publicatietype) {
    case publicatietypes.APPARAAT:
      break;

    case publicatietypes.ARTIKEL:
      rs = "file";
      break;

    case publicatietypes.AUDIOCASSETTE:
      break;

    case publicatietypes.BACHELORPROEF:
      rs = "education";
      break;

    case publicatietypes.BOEK:
      rs = "book";
      break;

    case publicatietypes.CD:
    case publicatietypes.CDROM:
    case publicatietypes.DVD:
    case publicatietypes.CDTRACK:
      rs = "cd";
      break;

    case publicatietypes.DEELTITEL:
      rs = "open-file";
      break;

    case publicatietypes.DIDACTISCH_MATERIAAL:
      break;

    case publicatietypes.E_BOEK:
    case publicatietypes.EBOEK:
      rs = "book";
      break;

    case publicatietypes.WEBSITE_DATABANK:
      rs = "globe";
      break;

    case publicatietypes.HANDBOEK_CURUSUS:
      rs = "book";
      break;

    case publicatietypes.LOSBLADIG_WERK:
      rs = "file";
      break;

    case publicatietypes.NASLAGWERK:
      break;

    case publicatietypes.POSTER:
      break;

    case publicatietypes.SPELMATERIAAL:
      rs = "tower";
      break;

    case publicatietypes.TIJDSCHRIFT:
      rs = "duplicate";
      break;

    case publicatietypes.TRANSPARANT:
      break;

    case publicatietypes.VIDEO:
      break;

    case publicatietypes.UNKNOWN:
      break;

    default:
  }

  if (rs == "") {
    rs = publicatietype;
    console.log("GEEN ICOON VOOR TYPE:", publicatietype);
  }

  return prefix + rs;
};

export { publicatietypes, getPublicatieTypeLabel, getPublicatieTypeIcon };